<div style="width: 320px">
  <bb-ellipsis-ui
    [lineClamp]="2"
    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  ></bb-ellipsis-ui>
</div>
